import canAutoPlay from 'can-autoplay';
import Clappr from "@clappr/player";

export async function testLoadAutoplay() {
    console.log("%c AUTOPLAY TEST", "color:blue");
    let ua = window.navigator.userAgent;
    let msie = ua.indexOf("MSIE ");
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      return 'DISABLE';
    }

    // check if we can autoplay with audio
    const resp = await canAutoPlay.video({timeout:100, muted:false});
    console.log("UNMUTED RESPONSE=", resp);
    if( resp.result ) {
      return 'OK';
    }

    // mute only allowed
    const respMuted = await canAutoPlay.video({timeout:100, muted: true});
    console.log("MUTED RESPONSE=", respMuted);
    if( respMuted.result ) {
      return 'MUTEONLY';
    }

    return 'DISABLE';
}

export function formatDate(goLive) {
  let monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  let date = new Date(goLive * 1000);

  let hours = date.getHours();
  let minutes = date.getMinutes();
  let ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0'+minutes : minutes;

  let timezone = "";
  let timezoneRegx = date.toString().match(/\((.*)\)/);
  if (timezoneRegx && timezoneRegx.length > 0 ){
    timezone = timezoneRegx[1].replace(/[^A-Z]/g, '');
  }

  return monthNames[date.getMonth()] + " " + date.getDate() + " " + date.getFullYear() +
    " - " +  hours + ':' + minutes + ' ' + ampm + ' ' + timezone;
}


export function displaySpinnerBtn(player, hide = false) {
  let spinnerButton = player.getPlugin('spinner');
  if (spinnerButton) {
    if (hide) {
      Clappr.$(spinnerButton.el).hide();
    } else {
      Clappr.$(spinnerButton.el).show();
    }
  }
}

export function applyTemplate(player, canAutoplay = true) {
  console.log('Apply template changes');
  let videoEl = player.core.el.querySelector('video');
  let playButton = player.getPlugin('poster');

  if (videoEl) {
    Clappr.$(videoEl).attr('autoplay', 'autoplay');
    Clappr.$(videoEl).attr('playsinline', '');
    Clappr.$(videoEl).attr('webkit-playsinline', '');
  }

  // Create Hit the play button message and added above play button.
  let playWrapper = playButton.el.querySelector('.play-wrapper[data-poster]');
  Clappr.$(playWrapper).prepend('<p class="play-button-warning">Please press play to start the Stream.</p>');

  // create a overalay :: based on settings
  const trackingOverlay = document.createElement("div");
  trackingOverlay.id = 'tracking_overlay';
  trackingOverlay.style.position = 'absolute';
  trackingOverlay.style.bottom = '80px';
  trackingOverlay.style.left = '0';
  trackingOverlay.style.right = '0';
  trackingOverlay.style.margingLeft = 'auto';
  trackingOverlay.style.margingRight = 'auto';
  trackingOverlay.style.zIndex = '10000';
  player.core.el.appendChild(trackingOverlay);

  // if can't autoplay show hit play message
  if (canAutoplay) {
    displayPlayMsgEl(player, true);
  }
}

export function displayTrackingMessage(player, messageContainerId, trackId, message, delay, callback ) {
  const playerWrapper = player.core.el.querySelector("#tracking_overlay");
  if( playerWrapper ) {
    const el = document.createRange().createContextualFragment(message);
    playerWrapper.prepend(el);

    const buttons = playerWrapper.querySelectorAll("button");
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => {
        console.log('clicked');

        // remove element
        const elementToRemove = document.getElementById(messageContainerId);
        if (elementToRemove) {
            elementToRemove.remove();
        }

        // Acknowledge the submission with a small, auto-dismissing alert.
        displayTrackingConfirmation(player);

        if( callback ) callback(button, index, trackId );
      });
    });

    setTimeout(() => {
      const elementToRemove = document.getElementById(messageContainerId);
      if (elementToRemove) {
        elementToRemove.remove();
      }
    }, delay);
  }
}

// Small, auto-dismissing confirmation shown after the viewer submits an
// "Are you watching" tracking response.
export function displayTrackingConfirmation(player, text = 'Response submitted') {
  const playerWrapper = player.core.el.querySelector("#tracking_overlay");
  if (!playerWrapper) {
    return;
  }

  const toast = document.createElement('div');
  toast.className = 'tracking-confirmation';
  toast.setAttribute('style', [
    'display:flex',
    'align-items:center',
    'justify-content:center',
    'gap:8px',
    'max-width:300px',
    'margin:0 auto 8px',
    'padding:10px 16px',
    'background-color:#2e7d32',
    'color:#ffffff',
    'font-size:14px',
    'line-height:1.3',
    'text-align:center',
    'border-radius:6px',
    'box-shadow:0 2px 8px rgba(0,0,0,0.25)',
    'opacity:0',
    'transition:opacity 0.25s ease'
  ].join(';'));
  toast.innerHTML = '<span style="font-size:18px;line-height:1;">&#10003;</span>' +
    '<span>' + text + '</span>';
  playerWrapper.prepend(toast);

  // Fade in.
  requestAnimationFrame(() => { toast.style.opacity = '1'; });

  // Fade out and remove after a short delay.
  setTimeout(() => {
    toast.style.opacity = '0';
    setTimeout(() => { toast.remove(); }, 300);
  }, 2500);
}

export function displayPlayMsgEl(player, hide = false) {
  let playWrapper = player.getPlugin('poster').el.querySelector('.play-wrapper[data-poster]');
  let playMsgEl = Clappr.$(playWrapper).find('.play-button-warning');
  if (playMsgEl) {
    if (hide) {
      Clappr.$(playMsgEl).addClass('hide-msg');
    } else {
      Clappr.$(playMsgEl).removeClass('hide-msg');
    }
  }
}

export function displayPlayBtn(player, hide = false) {
  let playButton = player.getPlugin('poster');
  if (playButton) {
    if (hide) {
      Clappr.$(playButton.el).hide();
    } else {
      Clappr.$(playButton.el).show();
    }
  }
}

// handle are you watching functions
export function displayAreYouWatching(player, hide=false) {

}

export function isPlayVisible(player) {
  let playButton = player.getPlugin('poster');
  return Clappr.$(playButton.el).is(':visible');
}

export function isSpinnerVisible(player) {
  let spinnerButton = player.getPlugin('spinner');
  return Clappr.$(spinnerButton.el).is(':visible');
}
export const countries = [
  // {label: "Afghanistan", value: "AF"},
  // {label: "Åland Islands", value: "AX"},
  // {label: "Albania", value: "AL"},
  // {label: "Algeria", value: "DZ"},
  // {label: "American Samoa", value: "AS"},
  // {label: "Andorra", value: "AD"},
  // {label: "Angola", value: "AO"},
  // {label: "Anguilla", value: "AI"},
  // {label: "Antarctica", value: "AQ"},
  // {label: "Antigua and Barbuda", value: "AG"},
  // {label: "Argentina", value: "AR"},
  // {label: "Armenia", value: "AM"},
  // {label: "Aruba", value: "AW"},
  // {label: "Australia", value: "AU"},
  // {label: "Austria", value: "AT"},
  // {label: "Azerbaijan", value: "AZ"},
  // {label: "Bahamas", value: "BS"},
  // {label: "Bahrain", value: "BH"},
  // {label: "Bangladesh", value: "BD"},
  // {label: "Barbados", value: "BB"},
  // {label: "Belarus", value: "BY"},
  // {label: "Belgium", value: "BE"},
  // {label: "Belize", value: "BZ"},
  // {label: "Benin", value: "BJ"},
  // {label: "Bermuda", value: "BM"},
  // {label: "Bhutan", value: "BT"},
  // {label: "Bolivia", value: "BO"},
  // {label: "Bosnia and Herzegovina", value: "BA"},
  // {label: "Botswana", value: "BW"},
  // {label: "Bouvet Island", value: "BV"},
  // {label: "Brazil", value: "BR"},
  // {label: "British Indian Ocean Territory", value: "IO"},
  // {label: "Brunei Darussalam", value: "BN"},
  // {label: "Bulgaria", value: "BG"},
  // {label: "Burkina Faso", value: "BF"},
  // {label: "Burundi", value: "BI"},
  // {label: "Cambodia", value: "KH"},
  {label: "Canada", value: "CA"},
  // {label: "Cameroon", value: "CM"},
  // {label: "Cape Verde", value: "CV"},
  // {label: "Cayman Islands", value: "KY"},
  // {label: "Central African Republic", value: "CF"},
  // {label: "Chad", value: "TD"},
  // {label: "Chile", value: "CL"},
  // {label: "China", value: "CN"},
  // {label: "Christmas Island", value: "CX"},
  // {label: "Cocos (Keeling) Islands", value: "CC"},
  // {label: "Colombia", value: "CO"},
  // {label: "Comoros", value: "KM"},
  // {label: "Congo", value: "CG"},
  // {label: "Congo, The Democratic Republic of the", value: "CD"},
  // {label: "Cook Islands", value: "CK"},
  // {label: "Costa Rica", value: "CR"},
  // {label: "Cote D'Ivoire", value: "CI"},
  // {label: "Croatia", value: "HR"},
  // {label: "Cuba", value: "CU"},
  // {label: "Cyprus", value: "CY"},
  // {label: "Czech Republic", value: "CZ"},
  // {label: "Denmark", value: "DK"},
  // {label: "Djibouti", value: "DJ"},
  // {label: "Dominica", value: "DM"},
  // {label: "Dominican Republic", value: "DO"},
  // {label: "Ecuador", value: "EC"},
  // {label: "Egypt", value: "EG"},
  // {label: "El Salvador", value: "SV"},
  // {label: "Equatorial Guinea", value: "GQ"},
  // {label: "Eritrea", value: "ER"},
  // {label: "Estonia", value: "EE"},
  // {label: "Ethiopia", value: "ET"},
  // {label: "Falkland Islands(Malvinas)", value: "FK"},
  // {label: "Faroe Islands", value: "FO"},
  // {label: "Fiji", value: "FJ"},
  // {label: "Finland", value: "FI"},
  // {label: "France", value: "FR"},
  // {label: "French Guiana", value: "GF"},
  // {label: "French Polynesia", value: "PF"},
  // {label: "French Southern Territories", value: "TF"},
  // {label: "Gabon", value: "GA"},
  // {label: "Gambia", value: "GM"},
  // {label: "Georgia", value: "GE"},
  // {label: "Germany", value: "DE"},
  // {label: "Ghana", value: "GH"},
  // {label: "Gibraltar", value: "GI"},
  // {label: "Greece", value: "GR"},
  // {label: "Greenland", value: "GL"},
  // {label: "Grenada", value: "GD"},
  // {label: "Guadeloupe", value: "GP"},
  // {label: "Guam", value: "GU"},
  // {label: "Guatemala", value: "GT"},
  // {label: "Guernsey", value: "GG"},
  // {label: "Guinea", value: "GN"},
  // {label: "Guinea - Bissau", value: "GW"},
  // {label: "Guyana", value: "GY"},
  // {label: "Haiti", value: "HT"},
  // {label: "Heard Island and Mcdonald Islands", value: "HM"},
  // {label: "Holy See(Vatican City State)", value: "VA"},
  // {label: "Honduras", value: "HN"},
  // {label: "Hong Kong", value: "HK"},
  // {label: "Hungary", value: "HU"},
  // {label: "Iceland", value: "IS"},
  // {label: "India", value: "IN"},
  // {label: "Indonesia", value: "ID"},
  // {label: "Iran, Islamic Republic Of", value: "IR"},
  // {label: "Iraq", value: "IQ"},
  // {label: "Ireland", value: "IE"},
  // {label: "Isle of Man", value: "IM"},
  // {label: "Israel", value: "IL"},
  // {label: "Italy", value: "IT"},
  // {label: "Jamaica", value: "JM"},
  // {label: "Japan", value: "JP"},
  // {label: "Jersey", value: "JE"},
  // {label: "Jordan", value: "JO"},
  // {label: "Kazakhstan", value: "KZ"},
  // {label: "Kenya", value: "KE"},
  // {label: "Kiribati", value: "KI"},
  // {label: "Korea, Democratic People's Republic of", value: "KP"},
  // {label: "Korea, Republic of", value: "KR"},
  // {label: "Kuwait", value: "KW"},
  // {label: "Kyrgyzstan", value: "KG"},
  // {label: "Lao People'S Democratic Republic", value: "LA"},
  // {label: "Latvia", value: "LV"},
  // {label: "Lebanon", value: "LB"},
  // {label: "Lesotho", value: "LS"},
  // {label: "Liberia", value: "LR"},
  // {label: "Libyan Arab Jamahiriya", value: "LY"},
  // {label: "Liechtenstein", value: "LI"},
  // {label: "Lithuania", value: "LT"},
  // {label: "Luxembourg", value: "LU"},
  // {label: "Macao", value: "MO"},
  // {label: "Macedonia, The Former Yugoslav Republic of", value: "MK"},
  // {label: "Madagascar", value: "MG"},
  // {label: "Malawi", value: "MW"},
  // {label: "Malaysia", value: "MY"},
  // {label: "Maldives", value: "MV"},
  // {label: "Mali", value: "ML"},
  // {label: "Malta", value: "MT"},
  // {label: "Marshall Islands", value: "MH"},
  // {label: "Martinique", value: "MQ"},
  // {label: "Mauritania", value: "MR"},
  // {label: "Mauritius", value: "MU"},
  // {label: "Mayotte", value: "YT"},
  // {label: "Mexico", value: "MX"},
  // {label: "Micronesia, Federated States of", value: "FM"},
  // {label: "Moldova, Republic of", value: "MD"},
  // {label: "Monaco", value: "MC"},
  // {label: "Mongolia", value: "MN"},
  // {label: "Montserrat", value: "MS"},
  // {label: "Morocco", value: "MA"},
  // {label: "Mozambique", value: "MZ"},
  // {label: "Myanmar", value: "MM"},
  // {label: "Namibia", value: "NA"},
  // {label: "Nauru", value: "NR"},
  // {label: "Nepal", value: "NP"},
  // {label: "Netherlands", value: "NL"},
  // {label: "Netherlands Antilles", value: "AN"},
  // {label: "New Caledonia", value: "NC"},
  // {label: "New Zealand", value: "NZ"},
  // {label: "Nicaragua", value: "NI"},
  // {label: "Niger", value: "NE"},
  // {label: "Nigeria", value: "NG"},
  // {label: "Niue", value: "NU"},
  // {label: "Norfolk Island", value: "NF"},
  // {label: "Northern Mariana Islands", value: "MP"},
  // {label: "Norway", value: "NO"},
  // {label: "Oman", value: "OM"},
  // {label: "Pakistan", value: "PK"},
  // {label: "Palau", value: "PW"},
  // {label: "Palestinian Territory, Occupied", value: "PS"},
  // {label: "Panama", value: "PA"},
  // {label: "Papua New Guinea", value: "PG"},
  // {label: "Paraguay", value: "PY"},
  // {label: "Peru", value: "PE"},
  // {label: "Philippines", value: "PH"},
  // {label: "Pitcairn", value: "PN"},
  // {label: "Poland", value: "PL"},
  // {label: "Portugal", value: "PT"},
  // {label: "Puerto Rico", value: "PR"},
  // {label: "Qatar", value: "QA"},
  // {label: "Reunion", value: "RE"},
  // {label: "Romania", value: "RO"},
  // {label: "Russian Federation", value: "RU"},
  // {label: "RWANDA", value: "RW"},
  // {label: "Saint Helena", value: "SH"},
  // {label: "Saint Kitts and Nevis", value: "KN"},
  // {label: "Saint Lucia", value: "LC"},
  // {label: "Saint Pierre and Miquelon", value: "PM"},
  // {label: "Saint Vincent and the Grenadines", value: "VC"},
  // {label: "Samoa", value: "WS"},
  // {label: "San Marino", value: "SM"},
  // {label: "Sao Tome and Principe", value: "ST"},
  // {label: "Saudi Arabia", value: "SA"},
  // {label: "Senegal", value: "SN"},
  // {label: "Serbia and Montenegro", value: "CS"},
  // {label: "Seychelles", value: "SC"},
  // {label: "Sierra Leone", value: "SL"},
  // {label: "Singapore", value: "SG"},
  // {label: "Slovakia", value: "SK"},
  // {label: "Slovenia", value: "SI"},
  // {label: "Solomon Islands", value: "SB"},
  // {label: "Somalia", value: "SO"},
  // {label: "South Africa", value: "ZA"},
  // {label: "South Georgia and the South Sandwich Islands", value: "GS"},
  // {label: "Spain", value: "ES"},
  // {label: "Sri Lanka", value: "LK"},
  // {label: "Sudan", value: "SD"},
  // {label: "Suriname", value: "SR"},
  // {label: "Svalbard and Jan Mayen", value: "SJ"},
  // {label: "Swaziland", value: "SZ"},
  // {label: "Sweden", value: "SE"},
  // {label: "Switzerland", value: "CH"},
  // {label: "Syrian Arab Republic", value: "SY"},
  // {label: "Taiwan, Province of China", value: "TW"},
  // {label: "Tajikistan", value: "TJ"},
  // {label: "Tanzania, United Republic of", value: "TZ"},
  // {label: "Thailand", value: "TH"},
  // {label: "Timor - Leste", value: "TL"},
  // {label: "Togo", value: "TG"},
  // {label: "Tokelau", value: "TK"},
  // {label: "Tonga", value: "TO"},
  // {label: "Trinidad and Tobago", value: "TT"},
  // {label: "Tunisia", value: "TN"},
  // {label: "Turkey", value: "TR"},
  // {label: "Turkmenistan", value: "TM"},
  // {label: "Turks and Caicos Islands", value: "TC"},
  // {label: "Tuvalu", value: "TV"},
  // {label: "Uganda", value: "UG"},
  // {label: "Ukraine", value: "UA"},
  // {label: "United Arab Emirates", value: "AE"},
  // {label: "United Kingdom", value: "GB"},
  {label: "United States", value: "US"},
  // {label: "Minor Outlying Islands", value: "UM"},
  // {label: "Uruguay", value: "UY"},
  // {label: "Uzbekistan", value: "UZ"},
  // {label: "Vanuatu", value: "VU"},
  // {label: "Venezuela", value: "VE"},
  // {label: "Viet Nam", value: "VN"},
  // {label: "Virgin Islands, British", value: "VG"},
  // {label: "Virgin Islands, U . S . ", value: "VI"},
  // {label: "Wallis and Futuna", value: "WF"},
  // {label: "Western Sahara", value: "EH"},
  // {label: "Yemen", value: "YE"},
  // {label: "Zambia", value: "ZM"},
  // {label: "Zimbabwe", value: "ZW"}
];

export const states = {
  'CA': [
    {label: "Alberta", value: "AB"},
    {label: "British Columbia", value: "BC"},
    {label: "Manitoba", value: "MB"},
    {label: "New Brunswick", value: "NB"},
    {label: "Newfoundland and Labrador", value: "NL"},
    {label: "Northwest Territories", value: "NT"},
    {label: "Nova Scotia", value: "NS"},
    {label: "Nunavut", value: "NU"},
    {label: "Ontario", value: "ON"},
    {label: "Prince Edward Island", value: "PE"},
    {label: "Quebec", value: "QC"},
    {label: "Saskatchewan", value: "SK"},
    {label: "Yukon Territory", value: "YT"}
  ],
  'US': [
    {label: "Alabama", value: "AL"},
    {label: "Alaska", value: "AK"},
    {label: "American Samoa", value: "AS"},
    {label: "Arizona", value: "AZ"},
    {label: "Arkansas", value: "AR"},
    {label: "California", value: "CA"},
    {label: "Colorado", value: "CO"},
    {label: "Connecticut", value: "CT"},
    {label: "Delaware", value: "DE"},
    {label: "District Of Columbia", value: "DC"},
    {label: "Federated States Of Micronesia", value: "FM"},
    {label: "Florida", value: "FL"},
    {label: "Georgia", value: "GA"},
    {label: "Guam", value: "GU"},
    {label: "Hawaii", value: "HI"},
    {label: "Idaho", value: "ID"},
    {label: "Illinois", value: "IL"},
    {label: "Indiana", value: "IN"},
    {label: "Iowa", value: "IA"},
    {label: "Kansas", value: "KS"},
    {label: "Kentucky", value: "KY"},
    {label: "Louisiana", value: "LA"},
    {label: "Maine", value: "ME"},
    {label: "Marshall Islands", value: "MH"},
    {label: "Maryland", value: "MD"},
    {label: "Massachusetts", value: "MA"},
    {label: "Michigan", value: "MI"},
    {label: "Minnesota", value: "MN"},
    {label: "Mississippi", value: "MS"},
    {label: "Missouri", value: "MO"},
    {label: "Montana", value: "MT"},
    {label: "Nebraska", value: "NE"},
    {label: "Nevada", value: "NV"},
    {label: "New Hampshire", value: "NH"},
    {label: "New Jersey", value: "NJ"},
    {label: "New Mexico", value: "NM"},
    {label: "New York", value: "NY"},
    {label: "North Carolina", value: "NC"},
    {label: "North Dakota", value: "ND"},
    {label: "Northern Mariana Islands", value: "MP"},
    {label: "Ohio", value: "OH"},
    {label: "Oklahoma", value: "OK"},
    {label: "Oregon", value: "OR"},
    {label: "Palau", value: "PW"},
    {label: "Pennsylvania", value: "PA"},
    {label: "Puerto Rico", value: "PR"},
    {label: "Rhode Island", value: "RI"},
    {label: "South Carolina", value: "SC"},
    {label: "South Dakota", value: "SD"},
    {label: "Tennessee", value: "TN"},
    {label: "Texas", value: "TX"},
    {label: "Utah", value: "UT"},
    {label: "Vermont", value: "VT"},
    {label: "Virgin Islands", value: "VI"},
    {label: "Virginia", value: "VA"},
    {label: "Washington", value: "WA"},
    {label: "West Virginia", value: "WV"},
    {label: "Wisconsin", value: "WI"},
    {label: "Wyoming", value: "WY"},
  ]
};

export const localeValidate = {
  'AE': 'ar-AE',
  'BH': 'ar-BH',
  'DZ': 'ar-DZ',
  'EG': 'ar-EG',
  'IQ': 'ar-IQ',
  'JO': 'ar-JO',
  'KW': 'ar-KW',
  'SA': 'ar-SA',
  'SY': 'ar-SY',
  'TN': 'ar-TN',
  'BY': 'be-BY',
  'BG': 'bg-BG',
  'BD': 'bn-BD',
  'CZ': 'cs-CZ',
  'DE': 'de-DE',
  'AT': 'de-AT',
  'DK': 'da-DK',
  'GR': 'el-GR',
  'AU': 'en-AU',
  'CA': 'en-CA',
  'GB': 'en-GB',
  'GG': 'en-GG',
  'GH': 'en-GH',
  'HK': 'en-HK',
  'MO': 'en-MO',
  'IE': 'en-IE',
  'IN': 'en-IN',
  'KE': 'en-KE',
  'MT': 'en-MT',
  'MU': 'en-MU',
  'NG': 'en-NG',
  'NZ': 'en-NZ',
  'RW': 'en-RW',
  'SG': 'en-SG',
  'UG': 'en-UG',
  'US': 'en-US',
  'TZ': 'en-TZ',
  'ZA': 'en-ZA',
  'ZM': 'en-ZM',
  'PK': 'en-PK',
  'EC': 'es-EC',
  'ES': 'es-ES',
  'MX': 'es-MX',
  'PA': 'es-PA',
  'PY': 'es-PY',
  'UY': 'es-UY',
  'EE': 'et-EE',
  'IR': 'fa-IR',
  'FI': 'fi-FI',
  'FJ': 'fj-FJ',
  'FR': 'fr-FR',
  'GF': 'fr-GF',
  'GP': 'fr-GP',
  'MQ': 'fr-MQ',
  'RE': 'fr-RE',
  'IL': 'he-IL',
  'HU': 'hu-HU',
  'ID': 'id-ID',
  'IT': 'it-IT',
  'JP': 'ja-JP',
  'KZ': 'kk-KZ',
  'KR': 'ko-KR',
  'LT': 'lt-LT',
  'MY': 'ms-MY',
  'NO': 'nb-NO',
  'NP': 'ne-NP',
  'BE': 'nl-BE',
  'NL': 'nl-NL',
  'PL': 'pl-PL',
  'PT': 'pt-PT',
  'BR': 'pt-BR',
  'RO': 'ro-RO',
  'RU': 'ru-RU',
  'SI': 'sl-SI',
  'SK': 'sk-SK',
  'RS': 'sr-RS',
  'SE': 'sv-SE',
  'TH': 'th-TH',
  'TR': 'tr-TR',
  'UA': 'uk-UA',
  'VN': 'vi-VN',
  'CN': 'zh-CN',
  'TW': 'zh-TW'
};

export function toFormUrlEncoded(element,key,list){
  var list = list || [];
  if(typeof(element)=='object'){
    for (var idx in element)
      toFormUrlEncoded(element[idx],key?key+'['+idx+']':idx,list);
  } else {
    list.push(key+'='+encodeURIComponent(element));
  }
  return list.join('&');
}
